<custom-arena
  #customArena
  [navigationItems]="navigation"
  [logoIcon]="logoIcon"
  [logoMiniatureIcon]="logoMiniatureIcon"
  [updateToolBarTitles]="false"
  [currentUserName]="dataService.currentUserName"
  [userAvatar]="dataService.userAvatar"
  [showNavigationBorder]="false"
  [showToggleButton]="false"
  [userMessage]="false"
  [userNotification]="false"
  [showMenuToggleButton]="true"
  [userFunction]="dataService.getRole()"
  [contextMenuAdditionalItems]="contextMenuItems"
  (onNavigationItemClick)="onNavigationItemClick($event)"
  (getLoginInfo)="getLoginInfo($event)"
>
  <div toolBarFirstTitle>
    <div>
      <span class="tool-bar-title" (click)="redirectToCompanyList()"> {{ companyName }}</span>
      <i style="padding-left: 6px" class="dx-icon-chevronright" *ngIf="projectName"></i>
      <span class="tool-bar-title" (click)="redirectToProjectList()"> {{ projectName }}</span>
    </div>
  </div>
  <div *ngIf="measureName" toolBarSecondTitle>
    <div class="company-name-position layout-title-style">
      <span> {{ subProjectName }}</span>
      <i style="padding-left: 6px" class="dx-icon-chevronright" *ngIf="measureName"></i>
      <span> {{ measureName }}</span>
    </div>
  </div>

  <div headerIcons class="circular-background">
    <img class="favorite-icon" (click)="openFavoriteSideBar()" src="assets/images/Favorit.svg" />
  </div>
  <div headerIcons class="circular-background">
    <img class="contact-icon" src="assets/images/Kontakt.svg" (click)="openSupportPopup()" />
  </div>
  <div [ngClass]="{ 'is-loading': isLoading }" class="content-container" >
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="isLoading" class="loader-container" fxLayout="column" fxLayoutAlign="center center">
    <ubt-loader></ubt-loader>
  </div>
  <ubt-geods-favorite-list #favorites *ngIf="isFavoriteOpen" (closebtn)="closeFavorites()"> 
  </ubt-geods-favorite-list>
  

</custom-arena>
<abc-toast
  #toast
  [animation]="toastAnimation"
  [type]="'custom'"
  width="auto"
  [position]="toastPosition"
  [contentTemplate]="toastTemplate"
>
  <div *dxTemplate="let data of 'success'" class="successful-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'error'" class="failure-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'info'" class="info-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
</abc-toast>
<abc-popup
  #resetPasswordPopUp
  class="popup-style"
  [width]="'25%'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-Company-Title-Confirm-Delete')"
  [showCloseButton]="true"
>
  <barthauer-abc-management-users-user-settings
    (changedEvent)="afterPasswordReset()"
  ></barthauer-abc-management-users-user-settings>
</abc-popup>
<support-mail-popup #supportMailPopup></support-mail-popup>
